/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ViewChild} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule,PaginatorModule,InputSwitchModule,DropdownModule, TreeNode,ConfirmDialogModule} from 'primeng/primeng';
import {RouterModule} from "@angular/router";
import {HttpModule} from "@angular/http";
import {FormsModule, FormGroup, FormControl, Validators, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from "@angular/platform-browser";

import { Control_Ap } from '../../model/control_ap';
import { BeaconArea } from '../../model/beaconarea';
import { Control_Gps } from '../../model/control_gps';
import { ThirdPartyCompany } from '../../model/thirdpartycompany';
import { Location } from '../../model/location';
import { MDMPCONTCLS } from '../../model/mdmpolicycontrolclass';
import {MamAdminService} from '../../service/mam_service.component';
import { MdmPolicyTarget } from '../../model/mdmptgtmdl';
import { AppPlatform } from '../../model/enumModel';
import {ExDialogModule} from "../../component/dialog.component";
import {SelectItem, ConfirmationService} from "primeng/components/common/api";
import {MdmPolicyControl} from "../../model/mdmpolicycontrol";
import { MdmPolicy } from '../../model/mdmpolicy';
import {CommonModule} from "@angular/common";
import {TargetGroupModule} from "../../component/target_group.component";
import {TargetUserModule} from "../../component/target_user.component";
import {TargetDeviceModule} from "../../component/target_device.component";
import {TranslateServiceForm} from "../../translate/translate.service";
import {CompanyDropDownListModule} from "../../component/company-drop-down-list/company-drop-down-list.component";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS

@Component({

  selector: 'policy-config-location',
  templateUrl: 'policy_config_location.html'
})
export class PolicyConfigLocationComponent implements OnInit{

  private location_list :any[] = [];
  private control_gps_list : any[] = [];
  private control_ap_list : any[] = [];
  private control_beancon_list : any[] = [];
  private company_list : ThirdPartyCompany[] = [];
  private in_policycontrol_list : MDMPCONTCLS[] = [];
  private out_policycontrol_list : MDMPCONTCLS[] = [];
  private category_policycontrol_list : MDMPCONTCLS[] = [];
  private target_list : MdmPolicyTarget[] = [];
  private mdm_policy_model_list : MdmPolicy[] = [];
  activeTabNumber : number = 0;
  selectedResource: string[]=[];


  title : string;
  conditionShow : boolean =false;
  selectIsWhat : string ="location";
  tableList :any;
  policyShow : boolean;
  policyList : TreeNode[];

  tabDeviceTabNumber : number;
  tempNumber : number;


  policyControlClassList : any;
  selectedPolicyLists : any;

  tempItem :any;
  selectedDrop : any;
  selectItem : SelectItem[];
  inOutNumber : number = 0;

  /*정책*/
  tempSelectedd : any[]=[];
  tempClassList : any[]=[];
  cars : SelectItem[]=[];
  options : SelectItem[] = [];
  mdm_policy_control_default_list : MdmPolicyControl[] = [];
  conditionAllSelected : any;
  platform : string = "ANY";
  category : any;
  p_node : TreeNode;

  detailItem : any;
  policyAddShow : boolean;
  companyLists : SelectItem[]=[];
  selectedPolicy : any;
  policyAddForm : FormGroup;

  //정책적용대상
  targetAddShow : boolean = false;
  delTargets: any[]=[];
  delTargetIdx: any[] =[];
  setGroupTargetList : TreeNode[];
  setUserTargetList : any;
  setDeviceTargetList : any;
  getPolicyTargetLists : any;
  selectedGroupList : any;
  selectedUserList : any;
  selectedDeviceList : any;
  inOutType : string;
  @ViewChild('any') anyTab:any;
  @ViewChild('android') androidTab:any;
  @ViewChild('ios') iosTab:any;
  @ViewChild('osTab') osTab:any;
  @ViewChild('target') targetTab:any;

  selectedCompany : any;

  viewTypeTargett :any = "group";
  groupShow : boolean = false;
  targetTitle : any;
  private translate:TranslateServiceForm;
  constructor (private service : MamAdminService, private fb: FormBuilder, private confirmationService: ConfirmationService, private _translate: TranslateServiceForm, private logger : Logger) {
    this.translate = _translate;
    this.policyAddForm = this.fb.group({
      'name' : new FormControl('',Validators.required),
      'company' : new FormControl('',Validators.required),
      'type' : new FormControl('1'),
      'areaType'   : new FormControl('0'),
      'policyDesc' : new FormControl(''),
      'baseFlag' : new FormControl('false')
    });

    this.targetTitle  = this.translate.instant('BUTTON_OK2');
  }

  ngOnInit() {
    //this.getPassingCondtionDetailList(6);
    // this.getPolicyTarget('6', 1, 9999);
    //this.getPassingCondtionDetailList(7);

    //this.getPolicyTree(1);

  }


  onTabChange(event) {
    this.inOutNumber = event.index;
    if(this.activeTabNumber == 0){
      //in
      //this.selectedPolicyLists = this.in_policycontrol_list;
    }else{
      //out
      //this.selectedPolicyLists = this.out_policycontrol_list;
    }
  }

  getPassingCondtionDetailList(pId:number) {
    this.service.getPassingCondtionDetailList(pId).subscribe(
      value => {
        let obj = value;
        this.logger.debug("obj : ", value);
        this.logger.debug("location : ",  value.LOCATION);
        this.logger.debug("ap : ",  value.AP);
        this.logger.debug("beacon : ",  value.BEACON.content);
        this.logger.debug("gps : ",  value.GPS);

        this.logger.debug("detail : ",  obj.detail);
        if(value.LOCATION && value.LOCATION.length>0){ this.location_list = value.LOCATION; }else {this.location_list = [];}
        if(value.GPS && value.GPS.length>0){ this.control_gps_list = value.GPS; }else {this.control_gps_list = [];}
        if(value.BEACON.content && value.BEACON.content.length>0){ this.control_beancon_list = value.BEACON.content; }else {this.control_beancon_list = [];}
        if(value.AP && value.AP.length>0){ this.control_ap_list = value.AP; }else {this.control_ap_list = [];}
        if(value.IN && value.IN.length>0){
          let test = value.IN;
          for(let i =0;i<test.length;i++){
            test[i].controlValue = test[i].itemDefaultValue;
            test[i].name = this.translate.instant("MdmPolicyControlName_" + test[i].name);
          }
          this.in_policycontrol_list = test; }else {this.in_policycontrol_list = [];}
        if(value.OUT && value.OUT.length>0){
          let test = value.OUT;
          for(let i =0;i<test.length;i++){
            test[i].controlValue = test[i].itemDefaultValue;
            test[i].name = this.translate.instant("MdmPolicyControlName_" + test[i].name);
          }
          this.out_policycontrol_list = test; }else {this.out_policycontrol_list = [];}

        this.logger.debug("in : ",  value.IN);
        this.logger.debug("out : ",  value.OUT);
        this.logger.debug("selectedPolicyLists", this.selectedPolicyLists);
        this.selectedResource = [];
        /*this.selectedResource.splice(0);*/
        this.detailItem = obj.detail;

        if(this.detailItem && this.detailItem.length >0){

          this.detailItem.forEach(item => {
            if(item.useType == "TRUE"){
              this.selectedResource.push(item.passingCategory);
            }
          })
        }
        this.logger.debug("resource",this.selectedResource);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {

      }
    )
  }

  /*getPolicyTarget(pId:string, page:number, max:number){
   this.service.getPolicyTarget(pId, page, max).subscribe(
   value => {
   this.target_list = value.rows;
   this.logger.debug("target_list : ",  value);
   },
   error => {
   this.logger.error("-- error : " + error);
   },
   () => {
   this.logger.info("-- complate : ");
   }
   )
   }*/


  getLocationList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getLocationList(page, max, search, like, field).subscribe(
      value => {
        this.tableList = value.rows;
        //this.logger.debug("-- location_list :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  getBeaconList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getBeaconList(page, max, search, like, field).subscribe(
      value => {
        this.tableList = value.rows;
        //this.logger.debug("-- control_beancon_list :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  getApList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getApList(page, max, search, like, field).subscribe(
      value => {
        this.tableList = value.rows;
        //this.logger.debug("-- control_ap_list :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  getGpsList(page:number, max:number, search:string, like:string, field:string) {
    this.service.getGpsList(page, max, search, like, field).subscribe(
      value => {
        this.tableList = value.rows;
        //this.logger.debug("-- control_gps_list :", value);
      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  deletePolicyTarget(targetIdx : string,viewTypeTargett : string){
    this.service.deletePolicyTarget(targetIdx,viewTypeTargett).subscribe(
      value => {
        this.logger.debug("-- delete Targetvalue : " , value);
        if(value == 1 || value.result=="Ok"){
          alert(this.translate.instant('Operation_DELETE'));
        }
        if(viewTypeTargett == "group") this.getPolicyTargetList(this.selectedPolicy.id,viewTypeTargett);
        else this.getPolicyTargetList(this.selectedPolicy.id,viewTypeTargett,0,400);
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  getPolicyTargetList(policyId: number,type : string, page?:number, size?:number ){
    this.service.getPolicyTargetList(policyId, type, page, size).subscribe(
      value => {
        this.logger.debug("getPolicyTargetLists : ", value);
        if(type=="group") {this.setGroupTargetList = value; this.getPolicyTargetLists = value;}
        else if(type=="user") {this.setUserTargetList = value.content; this.getPolicyTargetLists = value.content;}
        else if(type=="device") {this.setDeviceTargetList = value.content; this.getPolicyTargetLists = value.content;}

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }

  deployPolicyTarget(policyId : number,type :string, list: any){
    this.service.deployPolicyTarget(policyId,type,list).subscribe(
      value => {
        this.logger.debug("-- deployPolicyTarget 한 결과값: " , value);
        if(value == 'deploy result URL'){
          alert(this.translate.instant('MESSAGE_Distribution_Ok'));
        }
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  /*addTargetList(policyId : number, type : string , params : any){
   this.service.addTargetList(policyId,type,params).subscribe(
   value => {

   this.logger.debug("-- addTargetList : " , value);
   },error=>{this.logger.error("-- error : " + error);}
   )
   }*/

  addTargetList(policyId : number, type : string , params : any){
    this.service.addTargetList(policyId,type,params).subscribe(
      value => {
        this.logger.debug("-- addTargetList : " , value);
        if( this.viewTypeTargett == "group") { this.getPolicyTargetList(this.selectedPolicy.id,"group"); this.delTargets = [];}
        else if( this.viewTypeTargett == "user") { this.getPolicyTargetList(this.selectedPolicy.id,"user",0,400); this.delTargets = [];}
        else if( this.viewTypeTargett == "device")  { this.getPolicyTargetList(this.selectedPolicy.id,"device",0,400); this.delTargets = [];}

        alert(this.translate.instant('MESSAGE_Target_Add_Ok'));
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  saveForLocation(id:number, item : any){
    this.service.saveForLocation(id,item).subscribe(
      value => {
        if(value == 0){
          alert(this.translate.instant('MESSAGE_Success_Ok'));
          //this.getNewPolicyTree(this.selectedCompany.id,1,"inOut");
        }else{
          alert(this.translate.instant('MESSAGE_Success_Fail'));
        }
        this.logger.debug("saveForLocation result : ",value);
      },error=>{this.logger.error("-- error : " + error);}
    )
  }

  getNewPolicyTree(companyId:number,type:number,diff:string){
    this.service.getNewPolicyTree(companyId,type,diff).subscribe(value =>{
        this.policyList = [];
        let item = value;
        if(item && item.length>0){
          item.forEach(val => {
            this.policyList.push({label:val.name,data:val});
          })
        }

      },
      error =>{this.logger.debug("error",error)});
  }

  //==============================================event -----------------------

  ConditionAdd(item){
    this.conditionShow = true;
    this.selectIsWhat = item;
    if(item == 'location'){
      this.title = this.translate.instant('LANG_LocationCondition');
      this.getLocationList(1,10, "","","");
    }else if(item == 'gps'){
      this.title = this.translate.instant('LANG_GPSCondition');
      this.getGpsList(1,10, "","","");
    }else if(item == 'ap'){
      this.title = this.translate.instant('LANG_ApCondition');
      this.getApList(1,10, "","","");
    }else if(item == 'beacon'){
      this.title = this.translate.instant('LANG_BeaconCondition');
      this.getBeaconList(1,10, "","","");
    }
  }

  onRowSelect(event){
    this.logger.debug("dd",this.selectedDrop);
    this.logger.debug(event);

  }

  onPolicyListSelect(evnet){
    this.logger.debug(event);
  }


  conditionSelected(event){
    this.logger.debug("컨디션들 선택",event);

  }

  conditionAddSelected(event){
    this.logger.debug("추가했을시 선택한것들",event);
    /*if(this.selectIsWhat == "location"){ this.tableList.push(event); }
     else if(this.selectIsWhat == "gps"){ this.tableList.push(event); }
     else if(this.selectIsWhat == "ap"){ this.tableList.push(event); }
     else if(this.selectIsWhat == "beacon"){ this.tableList.push(event); }*/
  }

  confirm(event){
    this.conditionShow = false;

    /*if(this.selectIsWhat == "location"){ this.location_list = []; this.location_list = this.selectedResourceLists; this.logger.debug("확인했을때 나오는",this.selectedResourceLists); }
     else if(this.selectIsWhat == "gps"){ this.control_gps_list = []; this.control_gps_list = this.selectedResourceLists; this.logger.debug("확인했을때 나오는",this.selectedResourceLists);}
     else if(this.selectIsWhat == "ap"){ this.control_ap_list = []; this.control_ap_list = this.selectedResourceLists; this.logger.debug("확인했을때 나오는",this.selectedResourceLists);}
     else if(this.selectIsWhat == "beacon"){ this.control_beancon_list = []; this.control_beancon_list = this.selectedResourceLists; this.logger.debug("확인했을때 나오는",this.selectedResourceLists);}

     */
  }


  policyListAdd(item){
    this.title = this.translate.instant('LANG_POLICY_listConfig');
    this.policyShow = true;
    this.logger.debug("item",item);
    this.tempClassList=[];
    this.tempSelectedd=[];
    this.inOutType = item;

    let tabArr = this.anyTab.tabs;
    for(let i=0;i<tabArr.length;i++){
      if(i==0){tabArr[i].selected=true;}
      else{tabArr[i].selected=false;}
    }

    let osArr = this.osTab.tabs;
    for(let i=0;i<osArr.length;i++){
      if(i==0){osArr[i].selected=true;}
      else{osArr[i].selected=false;}
    }
    this.getPolicyControlDefault(1,item);

  }

  policyListDel(item){
    if(item == "in"){

    }else{

    }
  }


  /*정책설정 추가시 목록*/
  getPolicyControlDefault(id:number, inAndOut : string) {
    this.service.getPolicyControlDefault(id).subscribe(
      value => {
        this.mdm_policy_control_default_list = value.default;
        if(inAndOut == "in"){
          this.conditionAllSelected = this.in_policycontrol_list;
        }else{
          this.conditionAllSelected = this.out_policycontrol_list;
        }
        this.logger.debug("mdm_policy_control_default_list : ", value);
        this.logger.debug("conditionAllSelected",this.conditionAllSelected);

        this.mdm_policy_control_default_list.forEach(item => {
          item.controlValue = item.itemDefaultValue;
          item.name = this.translate.instant("MdmPolicyControlName_" + item.name);
          if(this.conditionAllSelected && this.conditionAllSelected.length > 0){
            this.conditionAllSelected.forEach(val =>{

              if(item.id == val.id){
                if(val.itemDefaultValue.toUpperCase() == "TRUE"){
                  item.controlValue = true;
                }else if(val.itemDefaultValue.toUpperCase() == "FALSE"){
                  item.controlValue = false;
                }else{
                  item.controlValue = val.itemDefaultValue;
                }
                this.tempSelectedd.push(item);
              }

            });
          }

          if(item.controlValue == "TRUE"){
            item.controlValue = true;
          }else if(item.controlValue == "FALSE"){
            item.controlValue = false;
          }

          if(item.valueType.indexOf("&") != -1){
            this.options = this.getSelect(item.valueType);
            item.options = this.options;
          }

          if(item.category=="4000" && item.platform=="ANY"){
            this.tempClassList.push(item);
          }
        });
        this.logger.debug("tempClassList",this.tempClassList);

      },
      error => {
        this.logger.error("-- error : " + error);
      },
      () => {
        this.logger.info("-- complate : ");
      }
    )
  }


  getSearchFlatformAndCategory(category : string, platform : string){
    this.tempClassList = [];
    this.mdm_policy_control_default_list.forEach(item =>
    {
      if(item.category == category && item.platform == platform){
        this.tempClassList.push(item);
      }
    })
  }
  onTabDeviceType(event){
    this.tabDeviceTabNumber = event.index;
    this.tempClassList = [];
    if(this.tabDeviceTabNumber == 0){
      this.platform = "ANY";
      let tabArr = this.anyTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("4000", this.platform);
    }else if(this.tabDeviceTabNumber == 1){
      this.platform = "ANDROID";
      let tabArr = this.androidTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("2000", this.platform);
    }else if(this.tabDeviceTabNumber == 2){
      this.platform = "IOS";
      let tabArr = this.iosTab.tabs;
      for(let i=0;i<tabArr.length;i++){
        if(i==0){tabArr[i].selected=true;}
        else{tabArr[i].selected=false;}
      }
      this.getSearchFlatformAndCategory("3001", this.platform);
    }

  }

  anySelectCategory(event){
    this.category="400"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  androidSelectCategory(event){
    this.category = "200"+event.index;
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }
  iosSelectCategory(event){
    this.category = "300"+(event.index+1);
    this.getSearchFlatformAndCategory(this.category, this.platform);
  }

  getSelect(item) : SelectItem[]{

    let selectItem = item.split(";");

    this.selectItem=[];
    for(let i=0;i<selectItem.length;i++){
      let select = selectItem[i].replace("&","").split(":");
      if(select.length ==2){
        let value = select[0];
        let label = this.translate.instant(select[1]);

        this.selectItem.push({label:label ,value:value});
      }
    }
    /*this.logger.debug("selectItem",this.selectItem);
     this.logger.debug("what",typeof this.selectItem);*/
    return this.selectItem;

  }


  jungbokSearch(list) {
    for (let i = 0; i < this.tempSelectedd.length; i++) {
      if (this.tempSelectedd[i].id == list.id) {
        this.tempSelectedd.splice(i, 1);
      }
    }
  }

  dropdownChanging(event,list){

    this.jungbokSearch(list);
    this.tempSelectedd.push(list);
  }

  textChanging(event,list){

    this.jungbokSearch(list);
    this.tempSelectedd.push(list);
  }
  switchChanging(event,list){

    this.jungbokSearch(list);
    this.tempSelectedd.push(list);
  }


  // 출입정책트리----------------------------------------------------------------
  getPolicyTree(type:number) {
    this.service.getPolicyTree(type).subscribe(
      value => {
        this.logger.debug("policy Tree :", value);
        this.policyList = value;
      }, error => {this.logger.error("-- error : " + error); }
    )
  }

  onPolicySelect(event) {
    /*if(event.node.parent == null){  // select company
     return;
     }*/

    this.selectedPolicy = event.node.data;
    this.logger.debug("selectedPolicy :" , this.selectedPolicy);

    let tabArr = this.targetTab.tabs;
    for(let i=0;i<tabArr.length;i++){
      if(i==0){tabArr[i].selected=true;}
      else{tabArr[i].selected=false;}
    }

    let osArr = this.osTab.tabs;
    for(let i=0;i<osArr.length;i++){
      if(i==0){osArr[i].selected=true;}
      else{osArr[i].selected=false;}
    }

    let anyArr = this.anyTab.tabs;
    for(let i=0;i<anyArr.length;i++){
      if(i==0){anyArr[i].selected=true;}
      else{anyArr[i].selected=false;}
    }


    this.selectedUserList = [];
    this.selectedDeviceList = [];
    this.selectedGroupList = [];
    this.setGroupTargetList = [];
    this.setUserTargetList = [];
    this.setDeviceTargetList = [];

    this.viewTypeTargett = "group";

    this.getPassingCondtionDetailList(this.selectedPolicy.id);
    this.getPolicyTargetList(this.selectedPolicy.id,"group");

  }

  policyConfirm(event){
    this.policyShow = false;
    if(this.inOutType == "in"){
      this.in_policycontrol_list = this.tempSelectedd;
    }else{
      this.out_policycontrol_list = this.tempSelectedd;
    }


  }

  policyCancel(event){
    this.policyShow = false;
  }

  policyAdd(event){
    this.policyAddShow = true;
    this.title = this.translate.instant('LANG_Add_Access_Policy');
    let temp ;
    /*this.service.getCompanies(0,20).subscribe(
     value => {
     this.logger.debug("company Value", value);
     temp = value.content;
     this.companyLists = [];
     this.companyLists.push({label : '-----------------------', value : null});
     if(temp && temp.length>0){
     temp.forEach(item => {
     this.companyLists.push({label : item.name, value : item.id});
     })
     }

     },
     error => { this.logger.error("-- error : ", error); }
     )*/
    this.policyAddForm.reset();
    this.policyAddForm.get("name").setValue("");
    this.policyAddForm.get("type").setValue("1");
    this.policyAddForm.get("areaType").setValue("0");
    this.policyAddForm.get("baseFlag").setValue("false");
    this.policyAddForm.get("policyDesc").setValue("");

    this.companyLists = [];
    this.companyLists.push({label:this.selectedCompany.name,value: this.selectedCompany.id});
    this.policyAddForm.get('company').setValue(this.selectedCompany.id);
  }

  policyAddCancel(){
    this.policyAddShow = false;
  }

  policyDel(event){

    if(!this.selectedPolicy) {
      alert(this.translate.instant('MESSAGE_Select_Policy_Delete'));
      return;
    }

    if(this.selectedPolicy.id){
      this.confirmationService.confirm({
        message: this.translate.instant('MESSAGE_Want_Delete'),
        header: this.translate.instant('BUTTON_DEL'),
        icon: 'fa fa-trash',
        accept: () => {
          this.service.deletePolicy(this.selectedPolicy.id).subscribe(
            value => {
              alert(this.translate.instant('Operation_DELETE'));
              this.getNewPolicyTree(this.selectedCompany.id,1,"inOut");
            },
            error => { this.logger.error("-- error : ", error); }
          )
        }
      });

    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }

  }

  onSubmit(value){
    //this.logger.debug(value);
    //value.company = {id : value.company};

    this.logger.debug(value);

    this.service.insertPolicy(value).subscribe(
      value => {
        this.logger.debug("insertPolicy value", value);

        if(value && value.id>0){
          alert(this.translate.instant('MESSAGE_Success_Add_Policy'));
        }else{
          alert(this.translate.instant('MESSAGE_Fail_Add_Policy'));
        }
        this.getNewPolicyTree(this.selectedCompany.id,1,"inOut");

      },
      error => { this.logger.error("-- error : ", error); }
    )
    this.policyAddShow = false;
  }

  policySave(evnet){
    this.logger.debug("정책저장");

    let control = "";
    /*this.policyDetailSelected.forEach(
     data => {
     control += data.id +"="+data.controlValue+"|";
     }
     );*/
    let params = {
      location : '',
      gps : '',
      ap : '',
      beacon : '',
      accessIn : [],
      accessOut : [],
      locationUse : 1,
      gpsUse : 1,
      apUse : 1,
      beaconUse : 1,
      gateUse : 1,
      flag : 'save'
    };
    if(this.selectedPolicy){

      if(this.selectedResource && this.selectedResource.length > 0){
        this.selectedResource.forEach(val => {
          if(val=="LOCATION") params.locationUse=0;
          else if(val == "GPS") params.gpsUse = 0;
          else if(val == "AP") params.apUse = 0;
          else if(val == "BEACON") params.beaconUse = 0;
          else if(val == "SPEEDGATE") params.gateUse = 0;
        })
      }

      let tts = [];

      if(this.location_list && this.location_list.length >0){
        this.location_list.forEach(item => {
          tts.push(item.id);
        });
        params.location = tts.join(",");
      }
      if(this.control_gps_list && this.control_gps_list.length >0){
        tts = [];
        this.control_gps_list.forEach(item => {
          tts.push(item.id);
        });
        params.gps = tts.join(",");
      }
      if(this.control_ap_list && this.control_ap_list.length >0){
        tts = [];
        this.control_ap_list.forEach(item => {
          tts.push(item.id);
        });
        params.ap = tts.join(",");
      }
      if(this.control_beancon_list && this.control_beancon_list.length >0){
        tts = [];
        this.control_beancon_list.forEach(item => {
          tts.push(item.id);
        });
        params.beacon = tts.join(",");
      }

      if(this.in_policycontrol_list && this.in_policycontrol_list.length > 0){
        tts = [];
        this.in_policycontrol_list.forEach( item => {
          tts.push({key: item.id, val: item.controlValue});
        });
        params.accessIn = tts;
      }

      if(this.out_policycontrol_list && this.out_policycontrol_list.length > 0){
        tts = [];
        this.out_policycontrol_list.forEach( item => {
          tts.push({key: item.id, val: item.controlValue});
        });
        params.accessOut = tts;
      }

      this.saveForLocation(this.selectedPolicy.id,params);





    }else {
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }

    this.logger.debug("itemss",params);
  }

  //정책 적용대상
  policyTargetAdd(){
    if(this.selectedPolicy){

      this.targetAddShow = true;
      this.title = this.translate.instant('LANG_policyTargetTitle');
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }


  }
  policyTargetDel(){

    this.delTargets.forEach(item => {
      this.delTargetIdx.push(item.id);
    });
    this.logger.debug("items",this.delTargetIdx);

    this.deletePolicyTarget(this.delTargetIdx.join("|"),this.viewTypeTargett);
  }

  viewTypeTarget(event){
    if(this.selectedPolicy){
      if(event.index == 0) { this.getPolicyTargetList(this.selectedPolicy.id,"group"); this.delTargets = []; this.viewTypeTargett = "group"; this.groupShow = true;}
      else if(event.index ==1){ this.getPolicyTargetList(this.selectedPolicy.id,"user",0,400); this.delTargets = []; this.viewTypeTargett = "user"; this.groupShow = true;}
      else if(event.index ==2) { this.getPolicyTargetList(this.selectedPolicy.id,"device",0,400); this.delTargets = []; this.viewTypeTargett = "device"; this.groupShow = true;}
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
      return;
    }
  }

  groupTargetDeploy(event){
    this.logger.debug("그룹 배포");
    if(this.selectedPolicy){
      let groupList :any = this.getSeletingTargetItem(this.selectedGroupList);
      let pushTargetIdx = [];
      this.delTargets.forEach(item => {
        pushTargetIdx.push(item.id);
      });

      if(groupList.length >0 || this.getPolicyTargetLists.length>0){
        if(pushTargetIdx.length > 0) {
		  if(confirm(this.translate.instant('MESSAGE_CONFIRM_Group_Deploy'))) {
		    this.deployPolicyTarget(this.selectedPolicy.id,"group",pushTargetIdx);
          }
		} else {
          this.deployPolicyTarget(this.selectedPolicy.id,"group",groupList);
		}
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_Group'));
      }
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }
  }
  userTargetDeploy(event){
    this.logger.debug("유저 배포");
    if(this.selectedPolicy){
      let userList :any = this.getSeletingTargetItem(this.selectedUserList);
	  let pushTargetIdx = [];
      this.delTargets.forEach(item => {
        pushTargetIdx.push(item.id);
      });

      if(userList.length >0 || this.getPolicyTargetLists.length>0) {
	    if(pushTargetIdx.length > 0) {
		  if(confirm(this.translate.instant('MESSAGE_CONFIRM_User_Deploy'))) {
		    this.deployPolicyTarget(this.selectedPolicy.id,"user",pushTargetIdx);
          }
		} else {
          this.deployPolicyTarget(this.selectedPolicy.id, "user", userList);
		}
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_User'));
      }
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }
  }
  deviceTargetDeploy(event){
    this.logger.debug("디바이스 배포");
    if(this.selectedPolicy){
      let deviceList :any = this.getSeletingTargetItem(this.selectedDeviceList);
	  let pushTargetIdx = [];
      this.delTargets.forEach(item => {
        pushTargetIdx.push(item.id);
      });

      if(deviceList.length >0 || this.getPolicyTargetLists.length>0) {
        if(pushTargetIdx.length > 0) {
		  if(confirm(this.translate.instant('MESSAGE_CONFIRM_Device_Deploy'))) {
		    this.deployPolicyTarget(this.selectedPolicy.id,"device",pushTargetIdx);
		  }
		} else {
          this.deployPolicyTarget(this.selectedPolicy.id, "device", deviceList);
		}
      }else{
        alert(this.translate.instant('MESSAGE_Add_OneMore_Device'));
      }
    }else{
      alert(this.translate.instant('MESSAGE_Select_Policy_First'));
    }
  }

  getSeletingTargetItem(targets){
    let item = [];
    if(targets && targets.length > 0){
      targets.forEach(value =>{
        item.push(value.id);
      })
    }
    return item;
  }

  targetAddConfirm(){
    this.targetAddShow = false;
    this.logger.debug("groupList",this.selectedGroupList);
    this.logger.debug("userList",this.selectedUserList);
    this.logger.debug("deviceList",this.selectedDeviceList);

    // comapny :: url = "/mgr/policy/" + this.selectedPolicy.id + "/company";
    //    - param : company id
    // group   :: url = "/mgr/policy/" + this.selectedPolicy.id + "/group";
    //    - parm  : group id list
    // user    :: url = "/mgr/policy/" + this.selectedPolicy.id + "/user";
    //    - parm : user id list
    // device  :: url = "/mgr/policy/" + this.selectedPolicy.id + "/device";
    //    - parm : device id list
    let grouplist:number [] = [];
    let userList = [];
    let deviceList = [];
    if(this.viewTypeTargett == "group"){
      if(this.selectedGroupList&& this.selectedGroupList.length > 0){
        //let url = "/mgr/policy/" + this.selectedPolicy.id + "/group";
        this.logger.debug("그룹리스트");
        for(let group of this.selectedGroupList){
          grouplist.push(group.id);
        }
        this.addTargetList(this.selectedPolicy.id,"group",grouplist);

      }else{ this.addTargetList(this.selectedPolicy.id,"group",grouplist); }
    }else if(this.viewTypeTargett == "user"){
      if(this.selectedUserList && this.selectedUserList.length > 0){
        this.selectedUserList.forEach(item =>{
          userList.push(item.id);
          //totalSelectedType.push("U");
        });
        this.addTargetList(this.selectedPolicy.id,"user",userList);

      }else{this.addTargetList(this.selectedPolicy.id,"user",userList);}
    }else if(this.viewTypeTargett == "device"){
      if(this.selectedDeviceList && this.selectedDeviceList.length > 0){
        this.selectedDeviceList.forEach(item =>{
          deviceList.push(item.id);
        });
        this.addTargetList(this.selectedPolicy.id,"device",deviceList);
      }else{ this.addTargetList(this.selectedPolicy.id,"device",deviceList); }
    }

  }

  targetAddCancel(){
    this.targetAddShow = false;
    this.selectedGroupList = [];
    this.selectedUserList = [];
    this.selectedDeviceList = [];
    if(this.viewTypeTargett == "group") this.getPolicyTargetList(this.selectedPolicy.id,this.viewTypeTargett);
    else this.getPolicyTargetList(this.selectedPolicy.id,this.viewTypeTargett,0,400);

  }

  onSelectedCompany(company) {
    this.selectedCompany = company;

    this.logger.debug("selectedComapny",this.selectedCompany);

    this.getNewPolicyTree(this.selectedCompany.id,1,"inOut");
    this.logger.debug("combo - select :" , this.selectedCompany);
  }

}

@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,OverlayPanelModule,ButtonModule, TreeModule,InputTextModule,InputTextareaModule,CheckboxModule,FormsModule,ExDialogModule,PaginatorModule,DropdownModule,InputSwitchModule,CheckboxModule,ConfirmDialogModule,CommonModule,ReactiveFormsModule,TargetGroupModule,TargetUserModule,TargetDeviceModule,CompanyDropDownListModule,TranslatePipeMoudle],
  exports: [PolicyConfigLocationComponent],
  declarations: [PolicyConfigLocationComponent],
  providers: [MamAdminService],
})
export class PolicyConfigLocationModule {
}



// WEBPACK FOOTER //
// ./src/app/page/policy/policy_config_location.ts